import { useState } from "react";
import {
  ModalState,
  EditingState,
  WhatsNewArticle,
} from "../types/whatsNew.types";

export const useWhatsNewModals = () => {
  const [modalState, setModalState] = useState<ModalState>({
    isFilterModalOpen: false,
    showDatePicker: false,
    videoModalOpen: false,
    currentVideoUrl: "",
  });

  const [editingState, setEditingState] = useState<EditingState>({
    openModal: false,
    operationType: "add",
  });

  // Modal state management
  const openFilterModal = () => {
    setModalState((prev) => ({ ...prev, isFilterModalOpen: true }));
  };

  const closeFilterModal = () => {
    setModalState((prev) => ({ ...prev, isFilterModalOpen: false }));
  };

  const showDatePicker = (show: boolean) => {
    setModalState((prev) => ({ ...prev, showDatePicker: show }));
  };

  const openVideoModal = (videoUrl: string) => {
    setModalState((prev) => ({
      ...prev,
      videoModalOpen: true,
      currentVideoUrl: videoUrl,
    }));
  };

  const closeVideoModal = () => {
    setModalState((prev) => ({
      ...prev,
      videoModalOpen: false,
      currentVideoUrl: "",
    }));
  };

  // Editing modal management
  const openAddModal = () => {
    setEditingState({
      openModal: true,
      operationType: "add",
      itemSelectedForEditing: undefined,
      indexToUpdate: undefined,
    });
  };

  const openEditModal = (article: WhatsNewArticle) => {
    setEditingState({
      openModal: true,
      operationType: "edit",
      itemSelectedForEditing: article,
      indexToUpdate: article.docId,
    });
  };

  const closeEditModal = () => {
    setEditingState({
      openModal: false,
      operationType: "add",
      itemSelectedForEditing: undefined,
      indexToUpdate: undefined,
    });
  };

  return {
    // Modal state
    modalState,
    editingState,

    // Modal actions
    openFilterModal,
    closeFilterModal,
    showDatePicker,
    openVideoModal,
    closeVideoModal,

    // Editing actions
    openAddModal,
    openEditModal,
    closeEditModal,
  };
};
